import React, { Component } from 'react';
import _ from 'lodash';
import DropdownMenu from 'react-dd-menu';
import './postal-dropdown-menu.scss';
import { withTranslation } from "react-i18next"

class PostalDropDownMenu extends Component {
  constructor() {
    super();
    this.state = {
      isMenuOpen: true
    };
    this.ref = React.createRef();

    this._handleClick = this._handleClick.bind(this)
    this._Choose = this._Choose.bind(this)
  }

  componentDidMount(){
    document.addEventListener('mousedown', this._handleClick);
  }

  componentWillUnmount(){
    document.removeEventListener('mousedown', this._handleClick);
  }

  _handleClick(){
    if(this.ref){
      this.close()
    }
  }

  _Choose(item){
    this.props.onClick(item)
  }

  toggle = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  close() {
    this.setState({ isMenuOpen: false });
  }

  render() {
    const menuOptions = _.assign(
      {
        isOpen: this.state.isMenuOpen,
        close: this.close.bind(this),
      },
      this.props.menuOptions || {}
    );

    const { menuItems,language } = this.props;
    const Toggle =
      this.props.toggle ||
      (({ onClick }) => (
        <button type="text" onClick={onClick}>
          Click me!
        </button>
      ));
    return (
      <div className="c-dropdown-postal" ref={this.ref}>
        {typeof menuItems === 'string' ? <div className="sp-blk"><p className="Form__error--9k-CR pt-t">{menuItems}</p></div> : 
          <DropdownMenu {...menuOptions}>
          {menuItems.map(item => (
              <li onClick={()=>this._Choose(item)} key={item.thaiPostalCodeId} toggle={<Toggle onClick={this.toggle} role="presentation"/>}>
                {(language === 'th' ? item.subdistrictNameThai + " >> " + item.districtNameThai + " >> " + item.provinceNameThai : item.subdistrictNameEng + " >> " + item.districtNameEng + " >> " + item.provinceNameEng ) + " >> " + item.postalCode}
              </li>
            ))}
          </DropdownMenu>
        }
      </div>
    );
  }
}
export default withTranslation()(PostalDropDownMenu)
